import { Controller, useForm } from 'react-hook-form';
import {
  InternationalSalesFeeFormData,
  schemaInternationalSalesFee,
} from '@src/types/feeSettings.ts';
import { useCallback } from 'react';
import { Button, Card, Checkbox, Input, InputSelect } from '@features/ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { StateOptions } from '@features/admin/feeSettings/feeSettingData.ts';

export const CreateInternationalSalesTaxPage = () => {
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<InternationalSalesFeeFormData>({
    resolver: yupResolver(schemaInternationalSalesFee),
  });

  const handleSubmitForm = useCallback(
    (data: InternationalSalesFeeFormData) => {
      console.log('data', data);
    },
    []
  );

  return (
    <div>
      <div className={'flex flex-col gap-y-2.5 w-fit'}>
        <p className={'text-[23px] font-medium text-blue'}>
          International Sales Tax
        </p>
        <div className={'h-[2px] w-full bg-blue'} />
      </div>
      <form autoComplete="off" onSubmit={handleSubmit(handleSubmitForm)}>
        <Card className={'text-xs mt-[18px]'}>
          <Controller
            control={control}
            name="country"
            render={({ field }) => (
              <div className={'flex flex-col gap-1 max-w-[500px]'}>
                <p>Country</p>
                <InputSelect
                  className={'text-xs'}
                  error={!!errors.country?.message}
                  options={StateOptions}
                  placeholder="Select"
                  value={field.value}
                  onChange={(value) => field.onChange(value)}
                />
              </div>
            )}
          />
          <div
            className={
              'flex gap-x-[81px] lg:flex-row flex-col gap-y-6 w-full mt-10 items-end'
            }
          >
            <Controller
              control={control}
              name="tax_rate"
              render={({ field }) => (
                <div className={'flex flex-col gap-1 max-w-[500px] flex-1'}>
                  <p>Tax Rate</p>
                  <Input
                    error={!!errors?.tax_rate?.message}
                    placeholder={'Enter %'}
                    textSize={'xs'}
                    type={'number'}
                    variant={'secondary'}
                    {...field}
                  />
                </div>
              )}
            />
            <Controller
              control={control}
              name={`apply_tax_to_shipping`}
              render={({ field }) => (
                <div className={'flex-1 lg:pb-2.5'}>
                  <Checkbox
                    checked={!!field.value}
                    label={'Apply rate to shipping amount'}
                    onCheckedChange={(value) => field.onChange(value)}
                  />
                </div>
              )}
            />
          </div>
          <div className={'flex justify-end'}>
            <Button
              className={'mt-[40px] mb-[30px]'}
              loading={isSubmitting}
              size={'sm'}
              variant={'lime'}
            >
              Save
            </Button>
          </div>
        </Card>
      </form>
    </div>
  );
};
